// extracted by mini-css-extract-plugin
export default {"container":"bDjOx","placeInfo":"KUory","ticketInfo":"AxdxX","ticketPrice":"OyAxP"};